import { FC, memo } from "react";
import { SIDE } from "_constants";
import { StatusMessageBase } from "components/common/StatusMessageBase";

type Props = {
  className?: string;
  team?: string | null;
  side: SIDE;
  Icon?: React.ComponentType<any>;
  title?: string;
  description?: string;
  normalizedCode: string;
  status: any;
  width: number;
  height: number;
};

export const StatusMessage: FC<Props> = memo((props) => {
  const normalizedValue = String(props.normalizedCode ?? "");
  const baseCode = normalizedValue.slice(-3);
  const bottomCodes: string[] = [];
  if (baseCode && !bottomCodes.includes(baseCode)) {
    bottomCodes.push(baseCode);
  }
  const sideIconResolver = (normalizedCode: string, side: "home" | "away") => {
    const { Icon } = props;
    const rotateCodes =
      normalizedCode === "1248" ||
      normalizedCode === "248" ||
      normalizedCode === "1250" ||
      normalizedCode === "1252" ||
      normalizedCode === "1253" ||
      normalizedCode === "9999";
    const isHome = side === "away";

    if (Icon && isHome && rotateCodes) {
      const Flipped: React.FC = () => (
        <div style={{ transform: "scaleX(-1)", transformOrigin: "center" }}>
          <Icon />
        </div>
      );
      return Flipped;
    }
    return Icon ?? null;
  };

  return (
    <StatusMessageBase
      {...props}
      bottomCodes={bottomCodes}
      accentColor="#381704"
      sideIconResolver={sideIconResolver}
    />
  );
});

export default StatusMessage;
